import {mergeStyles} from 'components/FluentUICompat';
import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.bubble.css';

type RichtextDisplayProps = {
	value: string;
	limit?: number;
	removeHtml?: boolean;
};

export const RichtextDisplay: React.FC<RichtextDisplayProps> = ({
	value,
	limit = Infinity,
	removeHtml = false,
}) => {
	const quillClassName = mergeStyles({
		'.ql-editor': {
			padding: 0,
		},
		'.ql-editor li[data-list=bullet] > .ql-ui::before': {
			content: 'none',
		},
	});

	let editedValue = value;

	if (removeHtml) {
		editedValue = value.replace(/<[^>]+>/g, '');
		return <>{editedValue}</>;
	}

	editedValue = editedValue
		.substring(0, limit)
		.concat(value.length > limit ? '...' : '');

	return (
		<ReactQuill
			value={editedValue}
			readOnly={true}
			theme={'bubble'}
			className={quillClassName}
		/>
	);
};
